<template>
   <div class="d-flex flex-column" v-if="isReady">
        
        <div class="d-flex flex-row justify-content-between">
            <h2 class="p-3 d-flex align-items-center">{{isEdit ? 'Edit Rule Group' : 'New Rules Group'}}</h2>
            
            <div class="d-flex justify-content-end align-items-center my-4 px-4">
                <button 
                    type="button" 
                    class="btn cancel wider mr-3" 
                    @click="btnCancel">Cancel
                </button>
                <input
					type="submit"
					value="Save"
					class="btn wider mr-3"
                    :disabled="finalRuleGroupValidations"
					@click="btnSave"
				/>
            </div>
        </div>

        <div class="new-product">
            <div class="my-4">
                <div class="px-4">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="panel mt-0 shaded radius-top-left-none radius-top-right-none">
                                <h5>Group Details:</h5>
                                <div class="row mt-3 row-min-height">
                                    <div class="col-xl-4 col-lg-4 col-md-6 mb-3 mr-4">
                                        <label class="mb-0">Name<span class="brand ml-1">*</span></label>

                                        <div class="pl-0 col-12">
                                            <input
                                                type="text"
                                                class="col-12 btn-height"
                                                placeholder="Example Group Name"
                                                v-model="rulesGroup.name"/>
                                        </div>

                                        <div v-if="$v.rulesGroup.name.$invalid" class="messages error">
                                            <span v-if="!$v.rulesGroup.name.required">Name is required.</span>
                                            <span v-if="!$v.rulesGroup.name.minLength">Name must have at least 5 characters.</span>
                                             <span v-if="!$v.rulesGroup.name.validCharacters">
                                                Invalid characters. Please use only letters, numbers, spaces, and the following special characters: <strong>{{specialCharacters}}</strong>
                                            </span>
                                        </div>
                                    </div>

                                     <div class="col-xl-2 col-lg-4 col-md-5 mb-5 booking-window-alignment mr-5">
                                        <span class="fs-small bold mr-2 text-nowrap">Booking Window</span>
                                        <toggle-button v-model="rulesGroup.isBookingWindowActive" @change="toggleShowInactive($event)" :labels="{checked: 'Yes', unchecked: 'No'}" />
                                    </div>
                                    
                                    <div class="d-flex col-xl-4 col-lg-5 col-md-6 mb-3" v-if="rulesGroup.isBookingWindowActive">
                                        <div class="col-7 col-md-8 pl-0">
                                            <label class="mb-0">From<span class="brand ml-1">*</span></label>
                                            <div class="d-flex col-6 pl-0">
                                                <v-select
                                                    label="val"
                                                    :value="bwFromInit"
                                                    :options="bwFromOptions"
                                                    class="select-width"
                                                    @input="bwUpdateVal($event, 'From')">
                                                </v-select>

                                               <div class="ml-2 time-picker-witdth" v-if="rulesGroup.bookingWindowFromType === 2">
                                                    <timepicker
                                                        :defaultTime="timerValue(rulesGroup.bookingWindowFrom)"
                                                        class="btn-height"
                                                        @change="rulesGroup.bookingWindowFrom = `${$event}:00`"
                                                        :disabled="false">
                                                    </timepicker>
                                                </div>
 
                                                <input
                                                    type="number"
                                                    class="col-8 btn-height ml-2"
                                                    v-model="rulesGroup.bookingWindowFrom"
                                                    v-if="rulesGroup.bookingWindowFromType === 1"/>
                                            </div>

                                            <div v-if="bwFromValidation" class="messages error">
                                                <span>From is required.</span>
                                            </div>
                                        </div>
                                        <div class="col-7">
                                            <label class="mb-0">Until<span class="brand ml-1">*</span></label>
                                            <div class="d-flex col-7 col-md-8 pl-0">
                                                <v-select
                                                    label="val"
                                                    :value="bwToInit"
                                                    :options="bwUntilOptions"
                                                    class="select-width"
                                                    @input="bwUpdateVal($event, 'To')">
                                                </v-select>

                                                <div class="ml-2 time-picker-witdth" v-if="rulesGroup.bookingWindowToType === 2">
                                                    <timepicker
                                                        :defaultTime="timerValue(rulesGroup.bookingWindowTo)"
                                                        class="btn-height"
                                                        @change="rulesGroup.bookingWindowTo = `${$event}:00`"
                                                        :disabled="false">
                                                    </timepicker>
                                                </div>
                                                
                                                <input
                                                    type="number"
                                                    class="col-8 btn-height ml-2"
                                                    v-model="rulesGroup.bookingWindowTo"
                                                    v-if="rulesGroup.bookingWindowToType === 1"/>
                                            </div>
                                            
                                            <div v-if="bwToValidation" class="messages error">
                                                <span>Until is required.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row mt-1 mb-2 row-min-height" v-if="rulesGroup.isBookingWindowActive">
                                    <div class="col-lg-2 col-md-4 mb-3">
                                        <transition name="fade">
                                            <div v-if="!(rulesGroup.bookingWindowFromType === 0 && rulesGroup.bookingWindowToType === 0)">
                                                <label class="mb-0">Occupation<span class="brand ml-1">*</span></label>
                                                <div class="d-flex col-9 pl-0">
                                                    <div class="d-flex">
                                                        <input 
                                                            class="glued-right btn-height col-6" 
                                                            type="number"
                                                            v-model.number="rulesGroup.occupancy"
                                                            @input="limitInput()">
                                                        <div class="glued-left">%</div>
                                                        
                                                        <v-select
                                                            autocomplete="no"
                                                            label="val"
                                                            :options="operatorOptions"
                                                            :value="operatorTypeInit"
                                                            class="ml-2 select-width"
                                                            @input="updateOperatorInfo($event)">
                                                        </v-select>
                                                    </div>
                                                </div>
                                            
                                                <div v-if="$v.rulesGroup.occupancy.$invalid || $v.rulesGroup.occupancyType.$invalid" class="messages error">
                                                    <span>Occupation is required.</span>
                                                </div>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                                
                                <h5>Rules:</h5>

                                <div class="row mb-5">
                                    <div class="col-sm-12 table-min-height" v-if="rulesLength > 0">
                                        <table class="w-100 table narrow">
                                            <thead>
                                                <tr class="thead-size">
                                                    <th width="60px" class="text-center"><span class="font-weight-700">Order</span></th>
                                                    <th width="30%" class="text-center"><span class="font-weight-700">Name</span></th>
                                                    <th width="auto" class="text-center"><span class="font-weight-700">Details</span></th>
                                                    <th width="25px" class="text-center">&nbsp;</th>
                                                </tr>
                                            </thead>
                                            <draggable v-model="rulesGroup.priceRules" :v-bind="draggableOptions" @change="updateOrder()" class="w-100" :tag="'tbody'">
                                                <tr class="stopRow w-100 tr-size"
                                                    v-for="rule, index in rulesGroup.priceRules"
                                                    :class="{ 'repetead-types-warning': rule.isRepeatedType }"
                                                    v-if="!rule.isDeleted">
                                                    <td class="overflowHidden">
                                                        <div class="routeMarker radius-circle">
                                                            <span class="fs-smaller radius-circle">{{rule.executionOrder}}</span>
                                                        </div>
                                                    </td>
                                                    <td class="">
                                                        <v-select 
                                                            class="w-100 d-inline-block align-middle" 
                                                            :options="existingRules"
                                                            :disabled="rule.isInGroup"
                                                            label="name"
                                                            :value="rule.name"
                                                            @input="updateRuleInfo(index, $event)">
                                                        </v-select>
                                                    </td>
                                                    <td class="text-center"><span class="w-100">{{rule.ruleDetails}}</span></td>
                                                    <td class="text-center pr-2">
                                                        <i  class="ico ico-delete m-1 fs-large pointer dark"
                                                            :style="{visibility: rulesGroup.priceRules.filter(item => !item.isDeleted).length === 1 ? 'hidden' : 'visible'}"
                                                            @click="removeRule(rule, index)"></i>
                                                    </td>
                                                </tr>
                                            </draggable>
                                        </table>

                                        <div v-if="hasRepeatedRules" class="messages error mt-3">
                                            <span>You can't have 2 or more rules of the same type in the group. Please remove one of the repeated rules!</span>
                                        </div>
                                        
                                        <div class="col-sm-4 mt-4" v-if="existingRules.length > 0">
                                            <div class="add d-flex align-items-center pointer fs-small bold btn-add" @click="addRule">
                                                <i class="ico-add fs-smallest add-circle color-1"></i> Add new
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else class="text-center dark col-sm-12 my-4">
                                        <div><i class="fs-large fa fa-file-contract color-6"></i>You have no Rules Groups, let's create one.</div>
                                        <button type="button" class="btn mt-3" @click="createRule">Create Rule</button>
                                    </div>

                                </div>

                                <h5>Notifications:</h5>

                                <div class="panel shaded col-sm-6 notification-min-heigth pl-0 border-0 pt-3">

                                    <div class="d-flex pb-1 mb-3">
                                        <label class="fs-normal darkest mr-5">Rule notification</label>
                                        <toggle-button v-model="rulesGroup.sendNotificationWhenRuleApplied" @change="toggleNotification($event)" :labels="{checked: 'Yes', unchecked: 'No'}" />
                                    </div>
                                    
                                    <div class="row" v-if="rulesGroup.sendNotificationWhenRuleApplied">
                                        <div class="col-sm-12">
                                            <label class="mb-1 darkest">Email <span class="normal fs-smaller dark ml-2">(You can enter multiple emails by separating them with comma ",")</span></label>
                                            
                                            <input  type="text"
                                                    class="mt-1 col-12"
                                                    placeholder="email1@domain.com, email2@domain.com, email3@domain.com"
                                                    v-model="rulesGroup.email">
                                        </div>

                                        <div v-if="$v.rulesGroup.email.$invalid" class="messages error ml-3">
                                            <span>When notifications are active email is required.</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Multiselect from 'vue-multiselect';
    import { required, minLength } from "vuelidate/lib/validators";
    import extendedVSelect from '@/extends/vue-select';
    import draggable from 'vuedraggable'
    import { rulesMixin } from '@/mixins/rules'
    import Timepicker from '@/tools/Timepicker'

    export default {
         data: function() {
            return {
                rulesGroup: {
                    name: "",
                    isBookingWindowActive: false,
                    bookingWindowFrom: " ",
                    bookingWindowTo: "1",
                    bookingWindowFromType: 0,
                    bookingWindowToType: 1,
                    occupancy: 0,
                    occupancyType: 1,
                    sendNotificationWhenRuleApplied: false,
                    email: null,
                    isDeleted: false,
                    priceRules: []
                },
                deletedRules: [],
                operatorOptions: [{val: '>', id: 1}, {val: '≥', id: 2}, {val: '<', id: 3}, {val: '≤', id: 4}],
                rulesIn: [],
                draggableOptions: {
                    draggable:'.stopRow',
                    animation: 200,
                },
                isEdit: false,
                ruleMap: {
                    '1-1-3': 'Base Price | Occupation (More then) | Price Increase',
                    '1-2-3': 'Base Price | Occupation (Less then) | Price Increase',
                    '2-1-1': 'Sales Channels | Occupation | Open/Close',
                    '2-1-3': 'Sales Channels | Occupation | Price Increase',
                    '2-4-2': 'Sales Channels | Number of Seats | Close',
                    '2-3-3': 'Sales Channels | Days of Week | Price Increase',
                    '3-1-3': 'Days of Week | Occupation | Price Increase',
                },
                selectedRuleGroupClone: null,
                rulesInInitGroup: [],
                isReady: false,
                specialCharacters: "<>|\\#$%/()=*+-_.:;,€ºª"
            }
        },
        validations: {
            rulesGroup: {
                name: {
                    required,
                    minLength: minLength(5),
                    validCharacters: function (val) {
                        return this.validCharacters(val);
                    }
                },
                bookingWindowFrom: {
                    required,
                },
                bookingWindowTo: {
                    required,
                },
                bookingWindowFromType: {
                    required,
                },
                bookingWindowToType: {
                    required,
                },
                occupancy: {
                    required,
                },
                occupancyType: {
                    required,
                },
                email: {
                    isEmailValid: function (val) {
                        return this.emailValidation(val);
                    },
                },
            },
        },
        beforeRouteEnter: function(to, from, next) {
            next(vm => {
                if (from.path === '/') {
                    vm.$router.push('/rules');
                    vm.clearSelectedItemRule();
                }  else  {
                    vm.isReady = true;
                    vm.initializeComponent();
                }
            });
        },
        destroyed() {
            if (this.isEdit) this.clearSelectedItemRule();
        },
        computed: {
            ...mapGetters([
                'getRules',
                'getSelectedRuleItem',
                'account',
                'getNewGroupRule'
            ]),
            finalRuleGroupValidations() {
                if ((!this.rulesGroup.isBookingWindowActive && !this.rulesGroup.sendNotificationWhenRuleApplied && this.isNameInvalid)
                    || (!this.rulesGroup.isBookingWindowActive && this.rulesGroup.sendNotificationWhenRuleApplied && (this.isNameInvalid || this.isEmailInvalid))
                    || (this.rulesGroup.isBookingWindowActive && !this.rulesGroup.sendNotificationWhenRuleApplied && (this.isNameInvalid || this.isBookingWindowInvalid || this.isOccupancyInvalid))
                    || (this.rulesGroup.isBookingWindowActive && this.rulesGroup.sendNotificationWhenRuleApplied && this.$v.rulesGroup.$invalid)
                    || this.hasRepeatedRules || this.rulesLength === 0) {
                    
                    return true;
                }
            },
            bwFromValidation() {
                if (this.rulesGroup.isBookingWindowActive && this.rulesGroup.bookingWindowFromType !== 0) {
                    if (this.$v.rulesGroup.bookingWindowFrom.$invalid || this.$v.rulesGroup.bookingWindowFromType.$invalid) {
                        return true;
                    }
                }
            },
            bwToValidation() {
                if (this.rulesGroup.isBookingWindowActive && this.rulesGroup.bookingWindowToType !== 0) {
                    if (this.$v.rulesGroup.bookingWindowTo.$invalid || this.$v.rulesGroup.bookingWindowToType.$invalid) {
                        return true
                    }
                }
            },
            isEditType() {
                if (this.getSelectedRuleItem !== null) {
                    this.rulesGroup = JSON.parse(JSON.stringify(this.getSelectedRuleItem.item));
                    this.selectedRuleGroupClone = this.createCloneRuleGroup(JSON.parse(JSON.stringify(this.getSelectedRuleItem.item)));
                }

                return this.isEdit = this.getSelectedRuleItem !== null ? true : false;
            },
            validPeriodStartTime() {
                let startTimeArray = '00:00'.split(":");
                return [
                    startTimeArray[0],
                    startTimeArray[1]
                ];
            },
            rulesLength(){
                return this.getRules.length;
            },
            existingRules() {         
                if (this.getRules.length === 0) {
                    this.downloadRules();
                }
                
                const existentRules = this.getRules.reduce((acc, rule) => {
                    const key = `${rule.targetVariableType}-${rule.conditionType}-${rule.actionType}`;
                    const belongToGroup = this.rulesInInitGroup.size > 0 && this.rulesInInitGroup.has(rule.id);
                    
                    acc.push({
                            name: rule.name,
                            ruleDetails: this.ruleMap[key],
                            priceRuleId: rule.id,
                            executionOrder: 1,
                            isDeleted: false,
                            isInGroup: belongToGroup,
                            type: key
                        })

                    return acc;
                },[]);
                
                const usedRules = new Set(this.rulesGroup.priceRules.map(rule => {
                    if (!rule.isDeleted) {
                        return rule.priceRuleId;
                    }
                }));

                return existentRules.filter(rule => !usedRules.has(rule.priceRuleId)).sort((a,b) => {
                    if (a.isInGroup && !b.isInGroup) {
                        return 1;
                    } else if (!a.isInGroup && b.isInGroup) {
                        return -1;
                    } else {
                        return 0;
                    }     
                });
            },
            operatorTypeInit() {
                const operators = {
                    1: '>',
                    2: '≥',
                    3: '<',
                    4: '≤'
                }

                return operators[this.rulesGroup.occupancyType];
            },
            bwFromInit(){
                const bwFromTypesMap = {
                    0: 'No Restrictions',
                    1: 'Days',
                    2: 'Hours'
                };

                return bwFromTypesMap[this.rulesGroup.bookingWindowFromType] || 'Unknown Type';
            },
            bwToInit(){
                const bwToTypesMap = {
                    0: 'Event Start',
                    1: 'Days',
                    2: 'Hours'
                };

                return bwToTypesMap[this.rulesGroup.bookingWindowToType] || 'Unknown Type';
            },
            bwFromOptions() {
                const bwToType = this.rulesGroup.bookingWindowToType;
                return this.generateBwOptions(bwToType !== 0, { val: 'No Restrictions', id: 0 });
            },
            bwUntilOptions() {
                const bwFromType = this.rulesGroup.bookingWindowFromType;
                return this.generateBwOptions(bwFromType !== 0, { val: 'Event Start', id: 0 });
            },
            isNameInvalid() {
                return this.$v.rulesGroup.name.$invalid;
            },
            isEmailInvalid() {
                return this.$v.rulesGroup.email.$invalid;
            },
            isBookingWindowInvalid() {
                return (
                    this.$v.rulesGroup.bookingWindowFrom.$invalid ||
                    this.$v.rulesGroup.bookingWindowTo.$invalid ||
                    this.$v.rulesGroup.bookingWindowFromType.$invalid ||
                    this.$v.rulesGroup.bookingWindowToType.$invalid
                );
            },
            isOccupancyInvalid() {
                return (
                    this.$v.rulesGroup.occupancy.$invalid ||
                    this.$v.rulesGroup.occupancyType.$invalid
                );
            },
            hasRepeatedRules() {
                return this.rulesGroup['priceRules'].filter(rule => rule.isRepeatedType).length > 1
            },
        },
        methods: {
            ...mapActions([
                'clearSelectedItemRule',
                'createRuleGroup',
                'updateRuleGroup',
                'downloadRules',
                'updateEditedRuleOrGroupToSave',
                'openModal',
                'startFullScreenLoading',
                'stopFullScreenLoading',
                'setNewGroupRule',
                'clearNewGroupRule'
            ]),
            generateBwOptions(condition, extraOption) {
                const options = [{ val: 'Hours', id: 2 }, { val: 'Days', id: 1 }];
                if (condition) {
                    options.push(extraOption);
                }
                
                return options;
            },
            validCharacters: function(val) {
                const allowedCharacters = /^[a-zA-Z0-9áàâãéêíóôõúçÁÀÂÃÉÊÍÓÔÕÚÇ\s<>|\\#$%\/()=*+\-_.:;,€ºª]*$/;
                
                return allowedCharacters.test(val);
            },
            initializeComponent() {
                if (this.isEditType) {
                    this.initEditRuleGroup();
                } else if (this.getNewGroupRule) {
                    this.rulesGroup = this.getNewGroupRule;
                    this.clearNewGroupRule();
                    this.addRule();
                } else {
                    this.addRule();
                }
            },
            createCloneRuleGroup(ruleGroup) {
                const { bookingWindowFrom, bookingWindowTo, priceRules, ...rest } = ruleGroup;

                const transformedPriceRules = priceRules.map(rule => ({
                    id: rule.id,
                    isDeleted: rule.isDeleted,
                    executionOrder: rule.executionOrder,
                    priceRuleId: rule.priceRule.id,
                }));

                return {
                    ...rest,
                    priceRules: transformedPriceRules,
                    bookingWindowFrom: bookingWindowFrom || " ",
                    bookingWindowTo: bookingWindowTo || " ",
                };
            },
            timerValue(time) {       
                let startTimeArray = '00:00'.split(":");

                if (time) {
                    const finalTime = time.split(':')
                    return [
                        finalTime[0], 
                        finalTime[1]
                    ]
                } else {
                    return [
                        startTimeArray[0],
                        startTimeArray[1]
                    ];
                }
            },
            updateOperatorInfo(val) {
                this.rulesGroup.occupancyType = val.id;
            },
            initEditRuleGroup() {
                this.rulesGroup.priceRules.map(groupRules => {
                    const key = `${groupRules.priceRule.targetVariableType}-${groupRules.priceRule.conditionType}-${groupRules.priceRule.actionType}`;
                    
                    groupRules.priceRuleId = groupRules.priceRule.id;
                    groupRules.ruleDetails = this.ruleMap[key];
                    groupRules.name = groupRules.priceRule.name;
                    groupRules.type = key;
                    groupRules.isInGroup = true
                    
                    delete groupRules.priceRule;
                })

                this.rulesInInitGroup = new Set(this.rulesGroup.priceRules.map(rule => {
                    if (rule.isInGroup) {
                        return rule.priceRuleId;
                    }
                }));

                if (!this.rulesGroup.isBookingWindowActive) {
                    this.rulesGroup.bookingWindowTo = "1";
                    this.rulesGroup.bookingWindowToType = 1;
                }

                this.rulesGroup.bookingWindowFrom = this.rulesGroup.bookingWindowFrom === "" ? " " : this.rulesGroup.bookingWindowFrom;
                this.rulesGroup.bookingWindowTo = this.rulesGroup.bookingWindowTo === "" ? " " : this.rulesGroup.bookingWindowTo;

                this.markRepeatedTypes();
            },
            emailValidation(val) {
                if (!val) {
                    return false;
                }

                let separator = null;
                
                if (val.includes(",")) {
                    separator = ",";
                } else if (val.includes(";")) {
                    separator = ";";
                }

                let emailArray = separator ? val.split(separator) : [val];

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

                return emailArray.every(email => emailRegex.test(email.trim()));
            },
            updateRuleInfo(idx, event) {
                if (this.isEdit) {    
                    if (event.isInGroup) {
                        const eventIdx = this.rulesGroup['priceRules'].findIndex(rule => rule.priceRuleId === event.priceRuleId);
                        this.rulesGroup['priceRules'][eventIdx].isDeleted = false;
                        this.$set(this.rulesGroup.priceRules, idx, this.rulesGroup['priceRules'][eventIdx])
                        this.rulesGroup['priceRules'].splice(eventIdx, 1);
                    } else {
                        this.$set(this.rulesGroup.priceRules, idx, event)
                    }
                } else {
                    this.$set(this.rulesGroup.priceRules, idx, event)
                }

                this.updateOrder();
            },
            limitInput() {
                const limitToDigits = (value, digits) => parseInt(value.toString().slice(0, digits));
                let value;

                value = this.rulesGroup.occupancy.toString();
                if (value.length > 3) this.rulesGroup.occupancy = limitToDigits(value, 3);
            },
            bwUpdateVal(event, type) {
                this.rulesGroup[`bookingWindow${type}Type`] = event.id;
                
                if (event.id === 1) {
                    this.rulesGroup[`bookingWindow${type}`] = "1";
                } else if (event.id === 2){
                    this.rulesGroup[`bookingWindow${type}`] = "00:00:00";
                } else {
                    this.rulesGroup[`bookingWindow${type}`] = " ";
                }
            },
            timePickers(val) {
                this.rulesGroup.bookingWindow.from.selectValue = val.toString();
            },
            createRule() {
                this.setNewGroupRule(this.rulesGroup);
                this.$router.push({ name: 'pluralo.rules.new' });
            },
            updateOrder() {
                if (this.rulesGroup.priceRules.length === 0) {
                    return false
                }

                this.rulesGroup.priceRules.map((rule, index) => {
                    if (!rule.isDeleted) {
                        rule.executionOrder = index + 1;
                    }
                })

                this.markRepeatedTypes();
            },
            markRepeatedTypes() {
                const typeCounts = {};

                // Count occurrences of each type
                this.rulesGroup['priceRules'].map(rule => {
                    if (!rule.isDeleted) {
                        typeCounts[rule.type] = (typeCounts[rule.type] || 0) + 1;
                    } else {
                        delete rule.isRepeatedType
                    }
                });

                // Add or remove the isRepeatedType property
                this.rulesGroup['priceRules'].map(rule => {
                    if (!rule.isDeleted) {
                        if (typeCounts[rule.type] > 1) {
                            rule.isRepeatedType = true;
                        } else {
                            delete rule.isRepeatedType;
                        }
                    } 
                });
            },
            addRule() {
                const lastValidIndex = this.rulesGroup.priceRules.findIndex(rule => rule.isDeleted);
                let alreadyAdded = null;
                let existingRules = this.existingRules.length > 0;
                
                this.rulesGroup.priceRules.map(rule => {
                    if (rule.isInGroup && rule.isDeleted && rule.priceRuleId === this.existingRules[0].priceRuleId) {
                        rule.isDeleted = false;
                        alreadyAdded = true;
                        rule.executionOrder = lastValidIndex + 1;
                    }
                })

                if (!alreadyAdded && existingRules) {
                    if (lastValidIndex === -1) {
                        this.rulesGroup.priceRules.push(this.existingRules[0])
                    } else {
                        this.rulesGroup.priceRules.splice(lastValidIndex, 0, this.existingRules[0])
                    }
                } else {
                    this.rulesGroup.priceRules.sort((a, b) => {
                        return a.executionOrder - b.executionOrder;
                    })
                }

                this.updateOrder();
            },
            removeRule(rule, idx) {
                if (!rule.isInGroup) {
                    this.rulesGroup.priceRules.splice(idx, 1);
                } else {
                    rule.isDeleted = true;
                    rule.executionOrder = this.rulesGroup.priceRules.length;
                    this.rulesGroup.priceRules.splice(idx, 1);
                    this.rulesGroup.priceRules.push(rule);
                }

                this.updateOrder();
            },
            btnCancel() {
                this.$router.push({ name: 'rules' });
            },
            btnSave() {
                const removeIgnoredProps = (obj, propsToIgnore) => {
                    return _.omit(obj, propsToIgnore);
                }

                const saveRuleGroup = (ruleGroup) => {
                    if (this.isEdit) {
                        const self = this;

                        if (ruleGroup.hasProductGroupAssossiation && 
                        !_.isEqual(removeIgnoredProps(ruleGroup, ['name']), removeIgnoredProps(self.selectedRuleGroupClone, ['name']))) {
                            
                            this.updateEditedRuleOrGroupToSave({rule: ruleGroup, type: 'ruleGroup'});
                            this.openModal('RuleSaveChanges');
                        } else {
                            this.initSavingProcess();

                            this.updateRuleGroup(ruleGroup).then((suc) => {
                                if (suc) {
                                    this.$toasted.success('Successfully saved', { duration: 2000 });
                                } else {
                                    this.$toasted.error('An error occurred', { duration: 2000 });
                                }

                                this.finalizeAndRedirect();
                            }).catch(error => {
                                this.errorHandling(error);
                            });
                        }
                    } else {
                        this.initSavingProcess();

                        this.createRuleGroup(ruleGroup).then((suc) => {
                            if (suc) {
                                this.$toasted.success('Successfully saved', { duration: 2000 });
                            } else {
                                this.$toasted.error('An error occurred', { duration: 2000 });
                            }

                            this.finalizeAndRedirect();
                        }).catch(error => {
                            this.errorHandling(error);
                        });
                    }
                };

                const finalRuleGroup = {...this.getCleanRuleGroup(), supplierId: this.account.supplierId};
                saveRuleGroup(finalRuleGroup);
            },
            errorHandling: function (error) {
                this.$toasted.error('An unexpected error occurred', { duration: 2000 });
                this.stopFullScreenLoading();
            },
            finalizeAndRedirect: function() {
                this.$router.push({ name: 'rules' });
                this.stopFullScreenLoading();
            },
            initSavingProcess: function() {
                this.$toasted.info('Saving', { duration: 2000 });
                this.startFullScreenLoading();
            },
            getCleanRuleGroup() {
                const cloneFinalRule = JSON.parse(JSON.stringify(this.rulesGroup));
                
                return {
                    ...cloneFinalRule,
                    priceRules: cloneFinalRule.priceRules.map(rule => {
                        const { name, ruleDetails, type, isInGroup, priceRule, ...rest } = rule;
                        return rest; 
                    })
                };
            },
            toggleShowInactive(e) {
                this.rulesGroup.isBookingWindowActive = e.value;
            },
            toggleNotification(e) {
                this.rulesGroup.sendNotificationWhenRuleApplied = e.value;
            }
        },
        components: {
            Multiselect,
            vSelect: extendedVSelect,
            draggable,
            Timepicker
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease, transform 0.5s ease;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
        transform: translateY(-10px);
    }

    .new-product {
        height: -webkit-fill-available;
        overflow-x: hidden;
        overflow-y: auto;
        background: white;
        margin: 0px 15px;
        margin-bottom: 15px;
    }

    .input-form-small {
        width: 75px;
    }

    .drop-small {
        white-space: nowrap;
        min-width: 80px;
    }

    .table-spot {
        height: 200px;
        width: -webkit-fill-available;
    }

    .rules-tables {
        background-color: #f5f8fa;
        border: 1px solid #c5d0de;
        padding: 5px;
        margin: 0px;
    }

    .btn-add {
        background-color: #f5f8fa;
        border: 1px solid #c5d0de;
        padding: 5px;
        padding-left: 10px;
        max-width: 150px;
    }

    .percentage {
        display: -webkit-inline-box;
        border: solid 1px #DBDFE2;
        height: 39px;
        padding-top: 8px;
        padding: 8px;
        border-bottom-right-radius: 3px;
        border-top-right-radius: 3px;
        background: #DBDFE2;
    }

    .row-min-height {
        min-height: 95px;
    }

    .btn-height {
        height: 39px;
    }

    .select-width {
        width: 9.5rem;
        min-width: fit-content;
    }

    .booking-window-alignment {
        margin-top: 26px;
        min-width: fit-content;
    }

    .overflowHidden{
        overflow: hidden;
    }

    table {
        th{
            font-weight: 400;
        }

        tbody tr:hover {
            border: none;
            transform: none;
        }
    }

    tbody .stopRow{
        overflow: hidden;
        cursor: grab;

        &.sortable-ghost{
            cursor: grabbing !important;
        }
    }

    tbody .stopRow:first-child .routeMarker span::before,
    tbody .stopRow:last-child .routeMarker span::after {
        display: none;
    }

    tbody .stopRow:first-child .routeMarker span,
    tbody .stopRow:only-child:last-child .routeMarker span {
        box-shadow: 0 0 0 2pt $color-3;
    }

    tbody .stopRow:last-child .routeMarker span {
        box-shadow: 0 0 0 2pt $color-6;
    }

    .routeMarker{
        position: relative;
        display: block;
        width: 20px;
        height: 20px;
        z-index: 1;
        margin: auto;

        span{
            position: absolute;
            text-align: center;
            width: 20px;
            height: 20px;
            background-color: $lightest;
            left: 0;
            top: 0;
            padding-top: 2px;
            box-shadow: 0 0 0 2pt $dark;
        }
    }

    .thead-size {
        height: 40px;
    }

    .tr-size {  
        height: 60px;
    }

    .table-min-height {
        min-height: 180px;
    }

    .time-picker-witdth {
        min-width: 95px;
    }

    .notification-min-heigth {
        min-height: 185px;
    }

    .repetead-types-warning {
        background-color: #ffe5e5;
    }
</style>



// WEBPACK FOOTER //
// NewRulesGroup.vue?2caf9a1f